import React, { useMemo } from 'react';
import { Spinner } from '@PetSureAustralia/petsure-react-ui-library/distLib/components';
import PropTypes from 'prop-types';

import './preloadWrapper.scss';

const PreloadWrapper = ({ children, loadingIcon = <Spinner />, isLoading = false, customCssClass, ...rest }) => {
  const wrapperCss = useMemo(
    () => `${rest.className ?? ''} preloadWrapper ${isLoading ? 'loading' : ''}`,
    [isLoading, rest.className]
  );

  return (
    <div
      className={`${wrapperCss} ${customCssClass ?? ''}`}
      {...rest}
    >
      {isLoading && (
        <div className="preloadContainer">
          <div className="preloadIcon">{loadingIcon}</div>
        </div>
      )}

      {children}
    </div>
  );
};

PreloadWrapper.propTypes = {
  children: PropTypes.node,
  loadingIcon: PropTypes.node,
  isLoading: PropTypes.bool,
  customCssClass: PropTypes.string
};

export { PreloadWrapper };
